import { Solutions } from "./solutions-graph-data";
import { AbstractGraph } from "../abstract-graph";
import { AppType } from "../../app.type";
import { GraphConfig } from "../graph.type";
import { Post } from "../../../../../shared/models/post";

export class SolutionsGraph extends AbstractGraph<Solutions> {
  get config(): GraphConfig {
    return {
      type: "bar-vertical-stacked",
      showXAxis: true,
      showYAxis: true,
      showLegend: true,
      xAxisLabel: null,
      yAxisLabel: null,
      colorScheme: {
        domain: ["#757575"],
      },
    };
  }

  constructor(protected app: AppType) {
    super(app);
  }

  protected getMap(map: Map<string, Solutions>) {
    const solutions = this.app.field.getOptions(
      this.app.fieldId.post.resolveClass
    );
    solutions.forEach((solution) => {
      map.set(solution, new Solutions(solution, this.app));
    });
    this.app.graphs.solutions.forEach((solution: Post) => {
      if (solution.resolveClass == null) {
        return;
      }
      const item = map.get(solution.resolveClass);
      if (item == null) {
        return;
      }
      item.add(solution);
    });
  }
}
